import { Flex, Tooltip } from '@mantine/core';
import PictureAsPDFIcon from '../../../components/icons/PictureAsPDF';
import LocalActivityIcon from '../../../components/icons/LocalActivity';
import OpenInPhoneIcon from '../../../components/icons/OpenInPhone';
import WarningIcon from '../../../components/icons/Warning';
import { IconPropsBase } from '../../../components/icons/IconPropsBase';
import { BrokerNerdsBarkerCoreEnumsTicketStock } from '../../../api';

export function TicketStockProperty({ ticketStockId }: { ticketStockId: BrokerNerdsBarkerCoreEnumsTicketStock }) {
  const friendlyName = getLocationFriendlyName(ticketStockId);

  return (
    <Tooltip label={friendlyName} withinPortal withArrow>
      <Flex w={22} h={22} bg="var(--colors-paper)" align="center" justify="center" style={{ borderRadius: 28 }} c="currentcolor">
        <TicketStockIcon ticketStockId={ticketStockId} size={16} />
      </Flex>
    </Tooltip>
  );
}

export function getLocationFriendlyName(ticketStockId: BrokerNerdsBarkerCoreEnumsTicketStock) {
  return ticketStockId === 'TicketmasterMobile' ? 'Mobile' : ticketStockId === 'Pdf' ? 'Electronic' : ticketStockId === 'Hard' ? 'Physical' : 'Unknown Ticket Stock';
}

export function TicketStockIcon({ ticketStockId, ...props }: IconPropsBase & { ticketStockId: BrokerNerdsBarkerCoreEnumsTicketStock }) {
  return ticketStockId === 'TicketmasterMobile' ? (
    <OpenInPhoneIcon {...props} />
  ) : ticketStockId === 'Pdf' ? (
    <PictureAsPDFIcon {...props} />
  ) : ticketStockId === 'Hard' ? (
    <LocalActivityIcon {...props} />
  ) : (
    <WarningIcon {...props} />
  );
}
